import React from 'react';
import './shared.css';

const MetricChip = ({ label, value, positive, neutral }) => {
  const className = neutral ? 'metric-neutral' : 
                    positive ? 'metric-positive' : 
                    'metric-negative';
  
  return (
    <span className={`metric-chip ${className}`}>
      <span className="metric-label">{label}</span>
      <span className="metric-value">{value}</span>
    </span>
  );
};

export default MetricChip;
